// Trend snapshot helpers (pure). Append after each successful reconcile;
// dedupe when nothing changed (no flat-line spam) and cap the ring buffer.
import type { NormalizedResult } from '../types/results.ts';
import type { Snapshot, MarginPoint } from '../types/snapshots.ts';
import type { Margin } from './reconcile.ts';
import { nowIso } from './time.ts';

export function makeSnapshot(raceId: string, primary: NormalizedResult, margin: Margin): Snapshot {
  return {
    t: nowIso(),
    raceId,
    primarySourceId: primary.sourceId,
    reportingPercent: primary.reportingPercent,
    leaderId: margin.leaderId,
    marginPct: margin.marginPct,
    marginVotes: margin.marginVotes,
    candidates: primary.candidates.map((c) => ({ id: c.id, votes: c.votes, percent: c.percent })),
  };
}

function sameData(a: Snapshot, b: Snapshot): boolean {
  if (a.primarySourceId !== b.primarySourceId) return false;
  if (a.reportingPercent !== b.reportingPercent) return false;
  if (a.candidates.length !== b.candidates.length) return false;
  return a.candidates.every((c, i) => {
    const o = b.candidates[i];
    return o != null && o.id === c.id && o.votes === c.votes && o.percent === c.percent;
  });
}

export function appendSnapshot(list: Snapshot[], snap: Snapshot, cap: number): Snapshot[] {
  const last = list[list.length - 1];
  if (last && sameData(last, snap)) return list; // nothing changed → skip
  const next = [...list, snap];
  return next.length > cap ? next.slice(next.length - cap) : next;
}

export function toMarginSeries(list: Snapshot[]): MarginPoint[] {
  return list.map((s) => ({
    t: s.t,
    leaderId: s.leaderId,
    marginPct: s.marginPct,
    reportingPercent: s.reportingPercent,
  }));
}
